export default {
  common: {
    clearAll: 'Alles Wissen',
    required: 'Vereist',
    restart: 'Herstarten'
  },
  createUser: {
    acceptTermsAndConditions: 'Accepteer de algemene voorwaarden',
    alreadyHaveAccount: 'Heb je al een account? %{pre}Downloaden%{post}',
    checkEmail: 'Download ondertussen Metrica Play naar je computer',
    clubCompany: 'Organisatie/Club',
    createdSuccessfully:
      'Registratie succesvol! Check je geregistreerde e-mail voor een verificatielink. (Check eventueel ook je spam)',
    email: 'E-mailadres',
    invalidEmail: 'Ongeldig e-mailadres',
    job: 'Functie/Rol',
    lastName: 'Achternaam',
    name: 'Voornaam',
    noCustomOption: 'Optie niet beschikbaar',
    noMatches: 'Geen overeenkomsten, voer je eigen optie in',
    password: 'Wachtwoord',
    passwordsDontMatch: 'Wachtwoorden komen niet overeen',
    passwordInvalid: 'Het wachtwoord voldoet niet aan de vereisten',
    passwordRequirements: {
      minLength: 'Minstens %{count} tekens',
      uppercase: 'Eén hoofdletter',
      lowercase: 'Eén kleine letter',
      number: 'Eén cijfer (0-9)',
      maxLength: 'Maximaal %{count} tekens'
    },
    phone: 'Telefoon',
    phoneCode: 'Land',
    proceed: 'Ga verder',
    repeatPassword: 'Herhaal Wachtwoord',
    searchPhoneCode: 'Zoeken…',
    seeTermsAndConditions: 'Zie de algemene voorwaarden',
    signAgreement:
      'Een account aanmaken bij Metrica Sports betekent dat je akkoord gaat met het %{pre1}Privacybeleid%{post1} en de %{pre2}Servicevoorwaarden%{post2}',
    signUpHere: 'Maak je account aan om te beginnen.',
    sport: 'Sport',
    submitting: 'Wordt gestart...',
    title: 'Ga aan de slag met %{product}',
    userKeyField: 'Heb je een Promocode of Gebruikerssleutel? Vul dit veld in'
  },
  error: {
    downloadPlay: 'Als je al een account hebt, download dan de nieuwste versie van Play en log in.',
    emailTaken: 'Dit e-mailadres is al in gebruik',
    fieldTooLong: 'Sommige velden zijn te lang. Maak ze korter en probeer het opnieuw',
    oops: 'Oeps!',
    restart:
      'Het lijkt erop dat je ergens in probeert te komen wat we nog aan het ontwikkelen zijn...',
    tryAgain:
      'Probeer het opnieuw. Als deze fout zich blijft voordoen, neem dan contact op met het Metrica Sports support-team',
    userKey:
      'Sleutel is niet geldig. Controleer je sleutel en probeer het opnieuw of verwijder het veld om de registratie te voltooien'
  },
  invitation: {
    acceptButton: 'Ik Accepteer Mijn Account Wijziging',
    accepting: 'Accepteren...',
    cancelButton: 'Afwijzen',
    description1:
      'Wanneer je wordt toegevoegd aan het nieuwe Metrica Sports-account, wordt het eigendom van je bestaande Metrica Sports-account (en de informatie die daarin is opgenomen) overgedragen en toegewezen aan de nieuwe eigenaar van het Metrica Sports-account. Alle informatie en gegevens die momenteel in je Metrica Sports-account staan, en alle informatie of gegevens die worden opgeslagen nadat je de wijziging van het account accepteert, zullen zichtbaar en beschikbaar zijn voor de nieuwe eigenaar van het Metrica Sports-account en voor elke beheerder(s) op dat account om te gebruiken en te delen met anderen naar goeddunken van de eigenaar van het account.',
    description2:
      'Door op "Ik accepteer mijn accountwijziging" te klikken, ga je akkoord met en machtig je het volgende:',
    list1:
      'De informatie van je huidige account zal worden overgezet naar het nieuwe Metrica Sports account.',
    list2:
      'Alle accountinformatie overgedragen naar je nieuwe Metrica Sports-account vanuit je huidige account kan worden beheerd door de nieuwe eigenaar van het account en/of beheerder(s).',
    list3:
      'In de nieuwe Metrica Sports-account zal je rol "Lid" zijn. Je zult niet langer eigenaar- of beheerdersrechten hebben van je huidige account.',
    list4:
      'Je zult de bestaande instellingen van je nieuwe Metrica Sports-account erven, die afhankelijk van je rol in het account meer of minder restrictief kunnen zijn, en je instellingen kunnen worden beheerd door de nieuwe eigenaar of beheerder(s) van het Metrica Sports-account.',
    list5:
      'Je huidige instellingen kunnen worden gewijzigd als ze in conflict zijn met de accountinstellingen van het nieuwe account waarbij je je aansluit.',
    list6:
      'Het is mogelijk dat je nieuwe account geen toegang biedt tot alle functies die je in je huidige account hebt.',
    list7:
      'Het is niet mogelijk om je accountoverdracht terug te draaien zodra je deze hebt geïnitieerd, en al je accountinformatie zal in één enkele account blijven.',
    list8:
      'Door op "Ik Accepteer Mijn Accountwijziging" te klikken, word je een beheerd lid van het account van %{pre1}%{email}%{post1} en ga je akkoord met de %{pre2}Algemene Voorwaarden%{post2} en de %{pre3}Privacyverklaring%{post3} van Metrica Sports.',
    subtitle:
      'Door deze nieuwe uitnodiging voor een Metrica Sports-account te accepteren, word je toegevoegd aan een ander Metrica Sports-account.',
    title: 'Uitnodiging'
  },
  jobs: {
    academyDirector: 'Opleidingsdirecteur',
    assistantCoach: 'Assistent-trainer',
    dataAnalyst: 'Data-analist',
    doctor: 'Arts',
    formerPlayer: 'Voormalig Speler',
    goalkeeperCoach: 'Keeperstrainer',
    headCoach: 'Hoofdtrainer',
    journalist: 'Journalist',
    other: 'Andere',
    performance: 'Fitness & Performance',
    player: 'Speler',
    scout: 'Scout',
    sportsDirector: 'Sportdirecteur',
    student: 'Student',
    videoAnalyst: 'Video-analist'
  },
  sports: {
    americanFootball: 'American Football',
    baseball: 'Honkbal',
    basketball: 'Basketbal',
    fieldHockey: 'Veldhockey',
    football: 'Voetbal',
    futsal: 'Futsal',
    gaelicFootball: 'Gaelic Voetbal',
    handball: 'Handbal',
    iceHockey: 'IJshockey',
    lacrosse: 'Lacrosse',
    netball: 'Netbal',
    other: 'Andere',
    padel: 'Padel',
    rugby: 'Rugby',
    tennis: 'Tennis',
    volleyball: 'Volleybal'
  }
}
